import { render } from "./FileSupport.vue?vue&type=template&id=48dca6fa&scoped=true&ts=true"
import script from "./FileSupport.vue?vue&type=script&lang=ts"
export * from "./FileSupport.vue?vue&type=script&lang=ts"

import "./FileSupport.vue?vue&type=style&index=0&id=48dca6fa&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48dca6fa"]])

export default __exports__